import sumBy from 'lodash/sumBy'

import {
  ManualTransactionsQuery,
  OrderRemainingBalanceDocument,
  PublicOrderRemainingBalanceDocument,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

import { Order } from '../../types'
import { CURRENCY_BY_COUNTRY, CurrencyByCountryType } from './constants'

const MIN_TRANSACTION = 0.5
const MIN_AMOUNT_ERROR_MSG =
  'Payment cannot be processed. Please enter an amount that results in a balance of more than .50'

type GetTotalInput = Pick<Order, 'lineItems' | 'shippingPrice' | 'taxAmount'>
export const getTotal = (order: GetTotalInput) => {
  const { lineItems, shippingPrice, taxAmount } = order

  return Number(lineItems?.discountedPrice ?? 0) + shippingPrice + taxAmount
}

export const validateAmountInput = (value = 0, remainingAmount: number) => {
  const remaining = remainingAmount - value
  return remaining > 0 && remaining < MIN_TRANSACTION
    ? MIN_AMOUNT_ERROR_MSG
    : ''
}

export const getCurrencyByCountry = (country?: string) =>
  CURRENCY_BY_COUNTRY[country?.toLowerCase() as CurrencyByCountryType]

export const getTotalPaidManualTransactions = (
  manualTransactions?: ManualTransactionsQuery['manualPaymentRecords'],
) => sumBy(manualTransactions, ({ amount }) => amount)

export const refetchRemainingBalance = ({
  isPublic = false,
}: { isPublic?: boolean } = {}) => {
  atlasClient.refetchQueries({
    include: [
      isPublic
        ? PublicOrderRemainingBalanceDocument
        : OrderRemainingBalanceDocument,
    ],
  })
}
